;(function ($, window, document) {
  $(document).on('shown.bs.collapse', function (event) {
    var $target = $(event.target)
    var $toggler = $('[data-target="#' + $target.attr('id') + '"]')
    if ($toggler.length) {
      if ($toggler.data('scroll-into-view')) {
        $toggler[0].scrollIntoView()
      }
    }
  })
})($, window, document)
